import React from 'react';

const ShareArticle = ({ url = '', title = '' }) => {
    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(title)}`,
        twitter: `https://x.com/intent/tweet?text=${encodeURIComponent(`${title} ${url}`)}`,
        whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(`${title} ${url}`)}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
        email: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`
    };

    return (
        <div className="share-article">
            <div className="social-sharing-small">
                <div className="social-sharing-title">
                    <span className="icon flaticon-share"></span> Partager cette formation :
                </div>
                <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                </a>
                <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-x-twitter"></i>
                </a>
                <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                </a>
                <a href={shareLinks.email} target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-envelope"></i>
                </a>
            </div>
        </div>
    );
};

export default ShareArticle;
